import { render, staticRenderFns } from "./CardItemEmployee.vue?vue&type=template&id=07fa1af6&"
import script from "./CardItemEmployee.vue?vue&type=script&lang=js&"
export * from "./CardItemEmployee.vue?vue&type=script&lang=js&"
import style0 from "./CardItemEmployee.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports